import React from "react"
import styled from "styled-components"
import { constants, fontWeight, fontSize } from "buoy-theme"
import Arrow from "./images/arrow.svg"
import {
  backgroundColor,
  textColor,
  hoverColor,
  hoverTextColor,
  borderColor,
  hoverBorderColor,
} from "./style"

const ButtonContainer = styled.a.attrs({
  role: "button",
})`
  ${fontSize("bodyMain")};
  font-weight: ${props =>
    props.large ? fontWeight.medium(props) : fontWeight.regular(props)};
  text-decoration: none;
  text-align: center;
  color: ${textColor};
  background-color: ${backgroundColor};
  ${props =>
    props.display
      ? `display: ${props.display};`
      : `
    display: flex;
    align-items: center;
    justify-content: center;
  `} letter-spacing: 0.2px;
  border-radius: 2px;
  min-width: ${props => (props.large ? "210px" : "128px")};
  padding: ${props => (props.large ? "15px 24px 17px" : "7px 20px 9px")};
  cursor: ${props => (props.disabled ? "not-allowed" : "pointer")};
  border: solid 1px ${borderColor};
  transition: all 300ms ease;

  ${props =>
    props.border &&
    `border: solid 1px ${props.theme.colors[props.color]};`} &:hover {
    background-color: ${hoverColor};
    border: solid 1px ${hoverBorderColor};
    color: ${hoverTextColor};
    img {
      transform: translateX(4px);
    }
  }
`

const ButtonArrow = styled.img`
  margin-left: 10px;
  transition: transform 0.5s;
`

const Button = props => (
  <ButtonContainer {...props}>
    {props.children}
    {props.arrow && <ButtonArrow src={Arrow} />}
  </ButtonContainer>
)

export { Button as default }



// WEBPACK FOOTER //
// ./src/components/Button/index.js